<template>
  <v-app>
    <v-app-bar app>
      <v-spacer></v-spacer>
      <!-- TITULO PAGINA -->
      <v-toolbar-title>
        {{ $t("app.tituloPagina") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <v-container
        fluid
        fill-height
        class="fundo d-flex flex-column align-center justify-center"
      >
        <v-card class="elevation-12" min-width="65vw">
          <v-card-title class="d-flex justify-center py-1"
            ><v-img
              max-width="127"
              :src="require('@/assets/logo-seara.png')"
              alt="Logo Seara"
            >
            </v-img
          ></v-card-title>
          <v-card-text>
            <h2 class="text-center mb-7">{{ $t("CadastroUsuario.titulo") }}</h2>
            <v-form
              ref="form"
              @submit.prevent="cadastro_usuario"
              autocomplete="off"
            >
              <v-row class="flex-column flex-sm-row">
                <!-- nome usuario -->
                <v-col class="py-0">
                  <v-text-field
                    :label="$t('CadastroUsuario.nome')"
                    type="text"
                    v-model="nome"
                    required
                    outlined
                    dense
                    clearable
                    :rules="obrigatorioRules"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                </v-col>

                <!-- e-mail -->
                <v-col class="py-0">
                  <v-text-field
                    :label="$t('CadastroUsuario.usuario')"
                    type="email"
                    v-model="usuario"
                    required
                    outlined
                    dense
                    clearable
                    :rules="obrigatorioRules"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="flex-column flex-sm-row">
                <!-- senha -->
                <v-col class="py-0">
                  <v-text-field
                    :label="$t('CadastroUsuario.novaSenha')"
                    v-model="senha"
                    required
                    outlined
                    dense
                    clearable
                    prepend-inner-icon="mdi-information"
                    @click:prepend-inner="janelaDicasSenha = !janelaDicasSenha"
                    :append-icon="
                      mostrarEsconderSenha ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="mostrarEsconderSenha = !mostrarEsconderSenha"
                    :type="mostrarEsconderSenha ? 'text' : 'password'"
                    :rules="obrigatorioRules"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                </v-col>

                <!-- confirmação senha -->
                <v-col class="py-0">
                  <v-text-field
                    :label="$t('CadastroUsuario.confNovaSenha')"
                    v-model="senhaConf"
                    required
                    outlined
                    dense
                    clearable
                    :append-icon="
                      mostrarEsconderSenhaConf ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    :type="mostrarEsconderSenhaConf ? 'text' : 'password'"
                    :rules="obrigatorioRules"
                    @click:append="
                      mostrarEsconderSenhaConf = !mostrarEsconderSenhaConf
                    "
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="flex-column flex-sm-row">
                <!-- idioma -->
                <v-col class="py-0">
                  <v-select
                    :items="idiomas"
                    :label="$t('CadastroUsuario.idioma')"
                    v-model="idioma"
                    required
                    outlined
                    dense
                    clearable
                    :rules="obrigatorioRules"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-divider class="mb-3"></v-divider>

              <v-row class="flex-column flex-sm-row">
                <!-- botão enviar cadastro -->
                <v-col>
                  <v-btn type="submit" color="primary" block large>
                    <v-icon left>mdi-account-plus </v-icon>
                    {{ $t("CadastroUsuario.btnEnviarCadastro") }}</v-btn
                  >
                </v-col>

                <!-- botão voltar -->
                <v-col>
                  <v-btn color="amber accent-1" block large @click="voltar">
                    <v-icon left>mdi-keyboard-return </v-icon>
                    {{ $t("CadastroUsuario.btnVoltar") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-container>

      <!-- ERROS NA TELA -->
      <v-bottom-sheet v-model="janelaErrosnaTela" inset>
        <!-- <v-sheet color="transparent"> -->
        <v-alert
          v-for="(item, key) in errosNaTela"
          :key="key"
          elevation="2"
          :type="item.tipo"
          transition="scale-transition"
          prominent
        >
          {{ item.descricao }} <br />
          {{ item.origem }}
        </v-alert>
        <!-- </v-sheet> -->
      </v-bottom-sheet>

      <v-dialog v-model="janelaDicasSenha" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            {{ $t("CadastroUsuario.dicasSenha.texto") }}
          </v-card-title>

          <v-card-text>
            <br />
            {{ $t("CadastroUsuario.dicasSenha.dica1") }}
            <br />
            {{ $t("CadastroUsuario.dicasSenha.dica2") }}
            <br />
            {{ $t("CadastroUsuario.dicasSenha.dica3") }}
            <br />
            {{
              $t("CadastroUsuario.dicasSenha.dica4") +
              " " +
              $t("CadastroUsuario.dicasSenha.dica41")
            }}
            <br />
            {{
              $t("CadastroUsuario.dicasSenha.dica5") +
              " " +
              $t("CadastroUsuario.dicasSenha.dica51")
            }}
            <br />
            {{ $t("CadastroUsuario.dicasSenha.dica6") }}
            <br />
            {{
              $t("CadastroUsuario.dicasSenha.dica7") +
              " " +
              $t("CadastroUsuario.dicasSenha.dica71")
            }}
            <br />
            {{ $t("CadastroUsuario.dicasSenha.dica8") }}
            <br />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "CadastroUsuario",
  data() {
    return {
      obrigatorioRules: [
        (v) => !!v || "Login.campoObrigatorio",
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      nome: "",
      usuario: "",
      senha: "",
      senhaConf: "",
      idioma: "",
      mostrarEsconderSenha: false,
      mostrarEsconderSenhaConf: false,
      janelaErrosnaTela: false,
      errosNaTela: [],
      janelaDicasSenha: false,
    };
  },
  methods: {
    async cadastro_usuario() {
      // console.log(this);
      // VALIDAR PREENCHIMENTO CAMPOS FORMULARIO HTML
      if (!this.$refs.form.validate()) {
        return false;
      }

      let urlLocal = "/pre_cadastro/cadastro_confirmar";
      let origemErro = "Origem: " + urlLocal;
      this.errosNaTela.splice(0);

      //Validar senhas iguais
      if (this.senha != this.senhaConf) {
        this.gerarAlerta(
          this.$i18n.t("CadastroUsuario.senhaNaoCoindice"),
          null,
          "error"
        );
        return false;
      }

      //Validar preenchimento idioma
      if (this.idioma == "") {
        this.gerarAlerta(
          this.$i18n.t("CadastroUsuario.selecioneIdioma"),
          null,
          "error"
        );
        return false;
      }

      //login
      let objLogin = {
        nome: this.nome,
        usuario: this.usuario.toLowerCase(),
        novaSenha: this.senha,
        idioma: this.idioma,
      };
      console.log(JSON.stringify(objLogin));

      // DEFINIR AMBIENTE DE EXECUÇÃO
      if (this.$ambiente == "DEV") urlLocal = this.$urlDEV + urlLocal;

      try {
        let response = await fetch(urlLocal, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          headers: {
            //   Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(objLogin),
        });
        let json = await response.json();

        let cd_mensagem;
        if (json.ds_retorno.indexOf(">") > -1)
          cd_mensagem = json.ds_retorno.split(">")[0].substr(1);
        else cd_mensagem = "N";

        //SUCESSO
        if (json.cd_retorno == "OK") {
          this.$refs.form.reset();
          let descricaoErro = this.$i18n.t("traducoesSrp." + cd_mensagem);
          this.gerarAlerta(descricaoErro, null, "success");

          //Voltar para Home
          // this.$router.push("/app/login");
          // window.location.href = json.ds_rota;
        } //ERRO
        else if (json.cd_retorno == "NOK") {
          if (cd_mensagem == "N") {
            let descricaoErro = json.ds_retorno;
            this.gerarAlerta(descricaoErro, origemErro, "warning");
          } else {
            let descricaoErro =
              "AVISO: " + this.$i18n.t("traducoesSrp." + cd_mensagem);
            this.gerarAlerta(descricaoErro, origemErro, "warning");
          }
        } //OTHERS
        else {
          let descricaoErro =
            "AVISO1: " + this.$i18n.t("traducoesSrp." + cd_mensagem);
          this.gerarAlerta(descricaoErro, origemErro, "warning");
        }
      } catch (error) {
        // ERRO MENSAGEM
        let descricaoErro = "OTHERS: " + error;
        this.gerarAlerta(descricaoErro, origemErro, "error");
      }
    },
    async voltar() {
      this.$router.push("/app/login");
    },
    gerarAlerta(descricaoErro, origemErro, tipo) {
      // console.log(descricaoErro, origemErro);
      this.errosNaTela.push({
        descricao: descricaoErro,
        origem: origemErro,
        tipo: tipo,
        timer: setTimeout(() => {
          this.errosNaTela.splice(0, 1);
        }, this.$tempoErrosNaTela),
      });
      this.janelaErrosnaTela = true;
    },
  },
  computed: {
    idiomas() {
      return [
        {
          text: this.$i18n.t("CadastroUsuario.idiomaPortugues"),
          value: "1",
        },
        {
          text: this.$i18n.t("CadastroUsuario.idiomaIngles"),
          value: "2",
        },
        {
          text: this.$i18n.t("CadastroUsuario.idiomaEspanhol"),
          value: "3",
        },
      ];
    },
  },
  mounted() {
    //Atualizar idioma do usuário
    let idioma = localStorage.getItem("idioma");
    if (idioma && this.$i18n.locale != idioma) {
      this.$i18n.locale = idioma;
      this.$vuetify.lang.current = idioma;
      document.documentElement.lang = idioma;
      document.title = this.$i18n.t("app.tituloPagina");
    }
  },
};
</script>

<style scoped>
/* IMAGEM DE FUNDO */
.fundo {
  background-image: url("../assets/fundo_sem_logo_claro.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>